import { useQuery } from '@tanstack/react-query';
import { auditApi } from '@/api/audit';

/**
 * Recent platform audit log entries for the admin log viewer. The backend
 * only exposes a bounded "most recent N" list for now (see auditApi.recent) -
 * there is no server-side pagination or search yet.
 */
export function useAuditLogs(limit = 100) {
  return useQuery({
    queryKey: ['audit-logs', limit],
    queryFn: () => auditApi.recent(limit),
  });
}
